"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { NestedComboBoxContext } from './use-nested-combobox.mjs';

function NestedComboBoxProvider({
  children,
  component
}) {
  return /* @__PURE__ */ jsx(NestedComboBoxContext.Provider, { value: component, children });
}

export { NestedComboBoxProvider };
